import React, { useEffect, useState } from 'react';
import { View, Modal, Button, Text } from 'react-native';
import { useNavigation } from "@react-navigation/native";
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';
import AuthCodeInput from '../../components/Form/AuthCodeInput';
import ModalPurchase from '../../components/ModalPurchase';

import AsyncStorage from '@react-native-async-storage/async-storage';

// import Button from '../../components/Button';

import api from '../../services/api'

import styles from './styles';

const ConfirmPassword = (props) => {

    const navigation = useNavigation();

    const [ password, setPassword ] = useState('');
    const [ emailCode, setEmailCode ] = useState()
    const [ codeVerification, setCodeVerification ] = useState(false)

    const [ modalVisible, setModalVisible ] = useState(false);
    
    const [ countDown, setCountDown ] = useState(null);

    useEffect(() => {
        resetPassword();
        verifyIfCodeIsCorrect()
    }, [ password, emailCode ])

    const getBuyToken = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        const idCoin = await AsyncStorage.getItem('id_coin');

        var data = {
            qtd: props.route.params.qtd.qtd,
            id_coin: idCoin,
            valueToken: props.route.params.qtd.valueToken,
        }

        // console.log('entrou na função getBuyToken()')

        api.post('marketplace-moviments', data, { headers: { 'Authorization': `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setModalVisible(!modalVisible);
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const getExchangeToken = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        const idCoin = await AsyncStorage.getItem('id_coin');

        var data = {
            quantity: props.route.params.qtd,
            id_token: idCoin,
            value: props.route.params.market == false ? props.route.params.valueCoin : null,
            is_purchase: props.route.params.purchase,
        }

        // console.log('entrou na função getExchangeToken()')

        api.post('exchange-order', data, { headers: { 'Authorization': `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setModalVisible(!modalVisible);
            })
            .catch((error) => {
                console.log(error);
            })
    }


    function resetPassword() {
        if (password.length === 6 && props.route.params.market == null && codeVerification === true && password != '') {
            console.log('entrou na função getBuyToken()')

            getBuyToken();
        } else if (password.length === 6  && codeVerification === true && password != '') {
            console.log('entrou na função getExchangeToken()')

            getExchangeToken();
        } else {
            console.log('não entrou em nada')
            setModalVisible(false)
        }
    }

    const timer = (seconds) =>  {
        let time = seconds * 1000
        return new Promise(res => setTimeout(res, time))
    }

    async function handleCounter() {
        for (var i = 60; i != 0; i--) {
            setCountDown(i)
            await timer(1);
        }
    }

    async function sendEmailVerification() {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        const config = {
            headers: { Authorization: "Bearer " + token }
        }

        if (token != null) {
            api.post(
                '/shippingEmail',
                {},
                config
            ).then( res => {
                // console.log(res)
            } )
        }
    }

    async function verifyIfCodeIsCorrect() {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        const config = {
            headers: { Authorization: "Bearer " + token }
        }

        // console.log(emailCode.length)

        if ( emailCode.length === 4 ) {
            api.post(
                '/confirmEmail',
                {
                    "confirm_action_code": emailCode
                },
                config
            ).then( (res) => {
                setCodeVerification(res.data.success)
            } )
        }
    }

    return (
        <>
            <HeaderDefault title={props.route.params.titlePage} />

            <View style={styles.container}>
                <FormattedMessage id='confirmPassword.lblDigiteSenha'>
                    {label =>
                    <AuthCodeInput
                        cellCount={6}
                        isPassword={true}
                        value={password}
                        onValueChange={(value) => setPassword(value)}
                        label={label}
                    />}
                </FormattedMessage>
            </View>

            <View style={styles.container}>
                <FormattedMessage id='confirmPassword.btnEnviaCodVerificacao'>
                    {titleBtn =>
                {
                    countDown==null?
                    <Button title={titleBtn} onPress={() => {
                        setCountDown(60)
                        handleCounter()

                        sendEmailVerification()
                    }} style={{ borderRadius: '10px' }} />

                        :
                        <View style={sendEmailStyle}>
                            <View>
                            <FormattedMessage id='confirmPassword.lblDigiteCodVerificacao'>
                                 {label =>
                                <AuthCodeInput
                                    style={{display: 'flex', flexDirection: 'column'}}
                                    cellCount={4}
                                    isPassword={true}
                                    // value={}
                                    onValueChange={(value) => setEmailCode(value)}
                                    label={label}
                                />}
                               </FormattedMessage>
                            </View>
                            <FormattedMessage id='confirmPassword.btnEnviar'>
                                 {titleBtn =>
                            {
                                countDown>1?
                                <Text>{countDown}</Text> :

                                <Button title={titleBtn}
                                onPress={() => {
                                    setCountDown(60)
                                    handleCounter()
            
                                    sendEmailVerification()
                                }}
                                style={{ borderRadius: '10px', fontSize: '12px' }}
                                ></Button>
                            }}
                            </FormattedMessage>
                        </View>
                        
                }}
                </FormattedMessage>
            </View>

            <Modal
                animationType="fade"
                transparent={false}
                visible={modalVisible}
                statusBarTranslucent={true}
                onRequestClose={() => navigation.navigate('Tabs')}
            >
                <ModalPurchase
                    handleCloseModal={() => {
                        setModalVisible(false);
                        navigation.navigate('Tabs');
                    }} />
            </Modal>
        </>
    );
}

const sendEmailStyle = {
    width: "80%",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
}

export default ConfirmPassword;